export default __webpack_public_path__ + "static/media/ic_wftm_30.b04d4875.svg";